import config from "@/config"
import http from "@/utils/request"

/**
 * 积分商城后台接口（商品 + 订单）
 * 挂载后通过 $API.integral.product.* / $API.integral.order.* 调用
 */
export default {
	product: {
		// 积分商品列表（EasyAdmin filter/op 搜索）
		index: {
			url: `${config.API_URL}/bwmall/admin/activity/integral/product/index`,
			name: "积分商品列表",
			get: async function(data = {}) {
				return await http.get(this.url, data)
			}
		},
		add: {
			url: `${config.API_URL}/bwmall/admin/activity/integral/product/add`,
			name: "新增积分商品",
			post: async function(data = {}) {
				return await http.post(this.url, data)
			}
		},
		// 编辑（GET 回显 / POST 保存同 URL）
		edit: {
			url: `${config.API_URL}/bwmall/admin/activity/integral/product/edit`,
			name: "编辑积分商品",
			get: async function(data = {}) {
				return await http.get(this.url, data)
			},
			post: async function(data = {}) {
				return await http.post(this.url, data)
			}
		},
		// 快速修改（is_show/is_host/sort）
		modify: {
			url: `${config.API_URL}/bwmall/admin/activity/integral/product/modify`,
			name: "修改积分商品",
			post: async function(data = {}) {
				return await http.post(this.url, data)
			}
		},
		del: {
			url: `${config.API_URL}/bwmall/admin/activity/integral/product/del`,
			name: "删除积分商品",
			post: async function(data = {}) {
				return await http.post(this.url, data)
			}
		},
		// 兑换规格（GET 回显 / POST 保存，POST 需拼 ?id=）
		attrGet: {
			url: `${config.API_URL}/bwmall/admin/activity/integral/product/attrList`,
			name: "积分规格回显",
			get: async function(id) {
				return await http.get(this.url, { id })
			}
		},
		attrPost: {
			url: `${config.API_URL}/bwmall/admin/activity/integral/product/attrList`,
			name: "积分规格保存",
			post: async function(id, data = {}) {
				return await http.post(this.url + '?id=' + id, data)
			}
		}
	},
	order: {
		// 兑换订单列表（含各状态数量 count）
		index: {
			url: `${config.API_URL}/bwmall/admin/activity/integral/order/index`,
			name: "积分订单列表",
			get: async function(data = {}) {
				return await http.get(this.url, data)
			}
		},
		info: {
			url: `${config.API_URL}/bwmall/admin/activity/integral/order/info`,
			name: "积分订单详情",
			get: async function(data = {}) {
				return await http.get(this.url, data)
			}
		},
		// 查看物流（GET ?id=订单ID，返回快递公司/轨迹时间线）
		express: {
			url: `${config.API_URL}/bwmall/admin/activity/integral/order/express`,
			name: "积分订单物流",
			get: async function(data = {}) {
				return await http.get(this.url, data)
			}
		},
		// 发货（type=1快递 2配送 3虚拟）
		delivery: {
			url: `${config.API_URL}/bwmall/admin/activity/integral/order/delivery`,
			name: "积分订单发货",
			post: async function(data = {}) {
				return await http.post(this.url, data)
			}
		},
		take: {
			url: `${config.API_URL}/bwmall/admin/activity/integral/order/take`,
			name: "积分订单收货",
			post: async function(data = {}) {
				return await http.post(this.url, data)
			}
		},
		// 取消订单并退积分
		cancel: {
			url: `${config.API_URL}/bwmall/admin/activity/integral/order/cancel`,
			name: "取消积分订单",
			post: async function(data = {}) {
				return await http.post(this.url, data)
			}
		},
		remark: {
			url: `${config.API_URL}/bwmall/admin/activity/integral/order/remark`,
			name: "积分订单备注",
			post: async function(data = {}) {
				return await http.post(this.url, data)
			}
		},
		del: {
			url: `${config.API_URL}/bwmall/admin/activity/integral/order/del`,
			name: "删除积分订单",
			post: async function(data = {}) {
				return await http.post(this.url, data)
			}
		}
	}
}
